
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import VersicherungenDetail from '@/components/Versicherungen/VersicherungenDetail.vue';
    import Versicherung from '@/types/Versicherung';
    import { LoadVersicherungenPayload, SetVersichungenDialogs, VersicherungenFilter } from '@/store/versicherungen';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            VersicherungenDetail,
        },
        computed: {
            ...mapState('versicherungen', ['versicherungen', 'dialogs', 'loaders']),
        },
        methods: {
            ...mapActions('versicherungen', ['loadVersicherungen']),
            ...mapMutations('versicherungen', ['setDialogs']),
        },
    })
    export default class Versicherungen extends Vue {
        public loadVersicherungen!: (payload?: LoadVersicherungenPayload) => void;
        public setDialogs!: (dialogs: SetVersichungenDialogs) => void;

        public versicherung = new Versicherung();
        public search = '';

        public filter: VersicherungenFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Versicherung> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Versicherung', value: 'versicherung' },
                { text: 'Bezeichnung', value: 'bezeichnung' },
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadVersicherungen({ filter: this.filter });
        }

        public onChangeFilter(): void {
            this.loadVersicherungen({ filter: this.filter });
        }

        public onClickEdit(versicherung: Versicherung): void {
            this.versicherung = { ...versicherung };
            this.setDialogs({ edit: true });
        }

        public onClickNew(): void {
            this.versicherung = new Versicherung();
            this.setDialogs({ edit: true });
        }
    }
